/* eslint-disable react/no-danger */
/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import moment from 'moment';
import ContractDate from 'components/atoms/contract_date';
import AtaRegistrationInfo from 'components/atoms/ata_registration_info';
import ContractsHeader from 'components/atoms/contracts_header';
import ClipboardIcon from 'components/atoms/clipboard_icon';
import MapLink from 'components/atoms/map_link';
import ModalOrganDetails from 'components/molecules/modal_organ_details';
import createTrack from 'services/actions/tracker_actions';
import { Container } from './styles';

interface AtaRegistrationPriceItemProps {
  toggleSelectedAtas: (id: number, updateAll?: boolean) => void;
  ata: any;
  AtaIndex: number;
  isChecked: boolean;
}

const AtaRegistrationPriceItem = (props: AtaRegistrationPriceItemProps) => {
  const { toggleSelectedAtas, ata, AtaIndex, isChecked } = props;
  const [showElement, setShowElement] = useState(false);
  const [modalOrganDetailsOpened, setModalOrganDetailsOpened] = useState<boolean>(false);

  return (
    <Container className="row mt-3">
      <div className="col-12 p-0">
        <div
          className={`card shadow bidding rounded position-relative mb-5 ${
            isChecked ? 'bidding_selected' : 'd-print-none'
          }`}
        >
          <ContractsHeader
            biddingId={ata?._source?.id}
            biddingIndex={AtaIndex}
            isChecked={isChecked}
            toggleSelectedBiddings={toggleSelectedAtas}
          />
          <div className="card-body p-4">
            <div className="tour-bidding-info">
              <div className="d-flex flex-column mb-2 bidding-info">
                <div className="d-flex">
                  <div className="bidding-info-title fs-16 pr-2 text-nowrap">Objeto:</div>
                  <div
                    className="flex-grow-1 fs-16 mb-2"
                    dangerouslySetInnerHTML={{ __html: ata?._source?.objeto || '-' }}
                  />
                </div>
              </div>
              <hr />
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title mr-2 text-nowrap">Vigência:</div>
                  <div className="text-secondary d-flex align-items-center">
                    <ContractDate
                      date={ata?._source?.atas[0]?.data_vigencia_inicio}
                      dateType="de"
                    />
                    <ContractDate date={ata?._source?.atas[0]?.data_vigencia_fim} dateType="a" />
                  </div>
                </div>
                <div className="col-md-8 d-flex">
                  <div className="bidding-info-title mr-2 text-nowrap">Órgão:</div>
                  <div>
                    <button
                      type="button"
                      aria-label="Clique para ver licitações já realizadas por esse órgão."
                      data-balloon-pos="up"
                      className="databalloon btn btn-link p-0 text-left break-text border-0"
                      onClick={() => {
                        setModalOrganDetailsOpened(true);
                        createTrack('Card - Clicou no órgão', { fonte: 'atas' });
                      }}
                    >
                      {ata?._source?.orgao?.uasg && `${ata?._source?.orgao?.uasg} - `}
                      {ata?._source?.orgao?.nome || '-'}
                      <i className="material-icons bidding-info-icon ml-1">info</i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title text-nowrap mr-2">Cidade:</div>
                  <div className="d-flex align-items-center gap-1">
                    <div className="text-secondary">
                      {ata?._source?.orgao?.cidade} - {ata?._source?.orgao?.estado}
                    </div>
                    <MapLink
                      address={`${ata?._source?.orgao?.endereco} ${ata?._source?.orgao?.cidade} ${ata?._source?.orgao?.estado}`}
                      source="atas"
                    />
                  </div>
                </div>
                <div className="col-md-8 d-flex">
                  <div className="bidding-info-title text-nowrap mr-2">Edital:</div>
                  <div
                    className="text-secondary"
                    dangerouslySetInnerHTML={{ __html: ata?._source?.edital || '-' }}
                  />
                </div>
              </div>
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  <div className="bidding-info-title text-nowrap mr-2">Fonte:</div>
                  <div className="text-secondary">{ata?._source?.atas[0]?.fonte || '-'}</div>
                </div>
                <div className="col-md-8 d-flex">
                  <div className="bidding-info-title text-nowrap mr-2">Id ata PNCP:</div>
                  <div className="text-secondary">
                    {ata?._source?.atas[0]?.numero_controle_pncp || '-'}
                  </div>
                </div>
              </div>
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  {ata?._source?.atas[0]?.document_date && (
                    <>
                      <div className="bidding-info-title text-nowrap mr-2">Data Fonte:</div>
                      <div className="text-secondary">
                        <ContractDate date={ata?._source?.atas[0]?.document_date} dateType="" />
                      </div>
                    </>
                  )}
                </div>
                <div className="col-md-8 d-flex">
                  <div className="bidding-info-title text-nowrap mr-2">Id contratação PNCP:</div>
                  <div className="text-secondary">
                    {ata?._source?.atas[0]?.numero_controle_pncp_compra || '-'}
                  </div>
                </div>
              </div>
              <div className="row bidding-info mb-2">
                <div className="col-md-4 d-flex align-items-center">
                  {ata?._source?.atas[0]?.data_assinatura && (
                    <>
                      <div className="bidding-info-title text-nowrap mr-2">Data da assinatura:</div>
                      <div className="text-secondary">
                        <ContractDate date={ata?._source?.atas[0]?.data_assinatura} dateType="" />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr className="mt-2" />
            <div className="row bidding-info mb-3 d-print-none">
              <div className="col-md-12">
                <div className="bidding-info-title mr-2 text-nowrap mb-1">Ações:</div>

                <div className="d-flex flex-wrap align-items-center gap-2">
                  <button
                    className="btn btn-primary btn-sm mr-1 mb-1"
                    type="button"
                    onClick={() => setShowElement(!showElement)}
                  >
                    Ata de Registro de Preços
                    {showElement ? (
                      <span className="oi oi-caret-top history-arrow ml-2" />
                    ) : (
                      <span className="oi oi-caret-bottom history-arrow ml-2" />
                    )}
                  </button>
                </div>
              </div>
            </div>
            {showElement && ata?._source?.atas && (
              <AtaRegistrationInfo dados={ata?._source?.atas} />
            )}
            <div
              className="d-flex justify-content-between align-items-center border-top pt-2 mt-3 text-secondary flex-column flex-md-row"
              style={{ fontSize: '12px' }}
            >
              <div>
                <span className="number-cnl font-weight-bold">Nº Conlicitação:</span>{' '}
                <span>{ata?._source?.id || '-'}</span>
                <ClipboardIcon
                  value={String(ata?._source?.id ?? '')}
                  action="Card Ata - Copiar número conlicitacao"
                />
              </div>
              <div>
                <span>Atualizada em: </span>
                <span>{moment(ata?._source?.modified || '').format('L [às] LT')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOrganDetailsOpened && (
        <ModalOrganDetails contract={ata} setModalOrganDetailsOpened={setModalOrganDetailsOpened} />
      )}
    </Container>
  );
};

export default AtaRegistrationPriceItem;
